// extracted by mini-css-extract-plugin
export default {"NavBar":"NavBar_NavBar__9Q-MV","MobileNavigation":"NavBar_MobileNavigation__LHiYj","Navigation":"NavBar_Navigation__J-A2g","burguer":"NavBar_burguer__HTUS+"};